import bus from "vue3-eventbus";

export default class ToastMessage {

    dismiss = true;
    timeout = 0;
    id = 0;
    targetId = null;
    icon = null;
    static defaultTimeout = 5000;
    description = '';

    constructor(description, targetId = null) {
        if (this.constructor === ToastMessage) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        this.description = description;
        this.id = Date.now() * 100 + Math.floor(Math.random() * 100);
        this.targetId = targetId;
        console.log('tid', this.targetId);
    }

    static emit(description, timeout = ToastMessage.defaultTimeout, targetId = null) {
        console.log('emit!', description, targetId);
        let message = new this(description, targetId);
        if (timeout) {
            message.setTimeout(timeout);
        }
        bus.emit('toastMessage', message);
    }

    static emitTarget(description, targetId,  timeout = ToastMessage.defaultTimeout) {
        this.emit(description, timeout, targetId);
    }

    setTimeout(timeout = ToastMessage.defaultTimeout) {
        this.timeout = timeout;
        this.dismiss = false;
        return this;
    }

    getDescription() {
        return this.description;
    }

    getTimeout() {
        return this.timeout;
    }

    getDismissible() {
    }
}

class ToastMessageType {
    type;
    cssClass;
    static SUCCESS = 'success';
    static DANGER = 'danger';
    static WARNING = 'warning';
    static INFO = 'info';

    getType() {
        return this.type;
    }
}

export class ToastMessageSuccess extends ToastMessage {
    type = ToastMessageType.SUCCESS;
    cssClass = 'alert-success';
    icon = 'data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01\' stroke=\'%2317A100\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E%0A';
}

export class ToastMessageDanger extends ToastMessage {
    type = ToastMessageType.DANGER;
    cssClass = 'alert-danger';
}

export class ToastMessageWarning extends ToastMessage {
    type = ToastMessageType.WARNING;
    cssClass = 'alert-warning';
}

export class ToastMessageInfo extends ToastMessage {
    type = ToastMessageType.INFO;
    cssClass = 'alert-info';
}
